export const juridicalPersonDataFormatter = (values) => ({
  ext1: values.companyPhoneExt,
  ext2: values.companyPhoneTwoExt,
  landline1: values.companyPhone,
  landline2: values.companyPhoneTwo,
  name: values.companyName,
  rfc: values.companyRfc,
  businessName: values.companySocialReason,
});
